<template>
  <div class="upload-content">
    <div
      v-if="url && url.length > 0"
      class="img-content"
      @mouseenter="showCover = true"
      @mouseleave="showCover = false"
    >
      <el-image class="img" :src="url" fit="contain" />
      <div v-show="showCover" class="cover-bg">
        <i
          class="el-icon-zoom-in icon-btn"
          @click.stop="showImgViewer = true"
        ></i>
        <i v-if="!disabled" class="el-icon-delete icon-btn" @click.stop="deleteCover()"></i>
      </div>
    </div>
    <el-upload
      v-else
      drag
      action=""
      :limit="1"
      :http-request="uploadCover"
      :accept="accept"
      :show-file-list="false"
      ref="upload"
    >
      <i class="el-icon-plus plus-icon"></i>
      <div class="el-upload__text">上传图片</div>
    </el-upload>
    <div class="upload_tip">
      <p v-if="name && name.length > 0">{{ name }}</p>
      <p class="img_tip">{{ tip }}</p>
    </div>

    <el-image-viewer
      v-if="showImgViewer"
      :on-close="
        () => {
          showImgViewer = false;
        }
      "
      :url-list="[url]"
    />
  </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import FileHandler from "@/utils/file";
export default {
  components: { ElImageViewer },
  props: {
    accept: {
      type: String,
      default: ".png,.jpg,.jpeg,.gif",
    },
    url: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 2,
    },
    name: {
      type: String,
      default: "",
    },
    tip: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ossPath: {
      type: String,
      default: "ding/img",
    },
  },
  data() {
    return {
      showCover: false,
      showImgViewer: false,
    };
  },
  created() {},
  activated() {},
  computed: {},
  model: {
    prop: "url",
    event: "returnBack",
  },
  methods: {
    // 上传图片
    async uploadCover(e) {
      let file = e.file;
      // 文件上传之前校验文件是否符合格式要求,符合继续上传，不符合终止上传
      if (file.size > this.size * 1024 * 1024) {
        this.$refs.upload.uploadFiles.pop();
        this.$message.warning(`附件大小不能超过${this.size}M,请重新选择文件`);
        return;
      }
      FileHandler.uploadFile(this.ossPath, file).then((res) => {
        const { url } = res;
        this.$emit("returnBack", url);
      });
    },
    // 删除图片
    deleteCover() {
      this.$emit("returnBack", null);
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-content {

  .img-content {
    width: 260px;
    height: 160px;
    position: relative;

    .img {
      width: 100%;
      height: 100%;
    }

    .cover-bg {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      background-color: rgba(1, 1, 1, 0.5);
      .icon-btn {
        color: #ffffff;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .plus-icon {
    margin-top: 30px;
    font-size: 28px;
    color: #8c939d;
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
  }

  .upload_tip {
    width: 280px;
    text-align: center;
    margin-top: 10px;
    p {
      font-size: 14px;
      margin: 0;
      line-height: 30px;
      color: #51627d;
    }
    p.img_tip {
      font-size: 12px;
      color: #96a1b2;
    }
  }
}
</style>
